import { DownloadPdfIcon } from '@/assets/icons';
import { memo } from 'react';

const DownloadButton = ({ onDownload }: { onDownload: () => void }) => {
	return (
		<div
			className="absolute top-1/2 right-10 -translate-y-1/2 cursor-pointer"
			onClick={onDownload}
		>
			<DownloadPdfIcon />
		</div>
	);
};
export default memo(DownloadButton);
